export const AdminNav = [
  {
    icon: "pe-7s-graph2",
    label: "Dashboard",
    to: "/dashboard",
  },
  {
    icon: "pe-7s-share",
    label: "Sources",
    content: [
      {
        label: "Add",
        to: "/source/add",
      },
      {
        label: "List",
        to: "/source/list",
      },
    ],
  },
  {
    icon: "pe-7s-map",
    label: "Cities",
    content: [
      {
        label: "Add",
        to: "/city/add",
      },
      {
        label: "List",
        to: "/city/list",
      },
    ],
  },
  {
    icon: "pe-7s-map",
    label: "Dynamic Meta Data",
    content: [
      {
        label: "Add",
        to: "/dynamicmetadata/add",
      },
      {
        label: "List",
        to: "/dynamicmetadata/list",
      },
    ],
  },
  {
    icon: "pe-7s-home",
    label: "Spots",
    content: [
      {
        label: "Add",
        to: "/spot/add",
      },
      {
        label: "Bulk Add",
        to: "/spot/bulk-add",
      },
      {
        label: "List",
        to: "/spot/list",
      },
    ],
  },
  {
    icon: "pe-7s-map-marker",
    label: "Parking Inventory",
    content: [
      {
        label: "Lots & Spots",
        to: "/parking-inventory/lots",
      },
    ],
  },
  {
    icon: "pe-7s-browser",
    label: "Pages",
    content: [
      // {
      //   label: "Add",
      //   to: "/page/add",
      // },
      {
        label: "Become a Host",
        to: "/page/become-a-host",
      },
      {
        label: "CMS",
        to: "/page/list",
      },
    ],
  },
  {
    icon: "pe-7s-user",
    label: "Admins",
    content: [
      {
        label: "Add",
        to: "/user/admin/add",
      },
      {
        label: "List",
        to: "/user/admin",
      },
    ],
  },
  {
    icon: "pe-7s-chat",
    label: "CSR",
    content: [
      {
        label: "Add",
        to: "/user/csr/add",
      },
      {
        label: "List",
        to: "/user/csr",
      },
    ],
  },
  {
    icon: "pe-7s-comment",
    label: "FAQ",
    content: [
      {
        label: "Add",
        to: "/faq/add",
      },
      {
        label: "List",
        to: "/faq/list",
      },
    ],
  },
  {
    icon: "pe-7s-chat",
    label: "Reviews",
    content: [
      {
        label: "Add",
        to: "/review/add",
      },
      {
        label: "List",
        to: "/review/list",
      },
    ],
  },
  {
    icon: "pe-7s-users",
    label: "Users",
    to: "/user/all",
    /*content: [
      {
        label: "All",
        to: "/user/all",
      },
      {
        label: "Hosts",
        to: "/user/hosts",
      },
      {
        label: "Renters",
        to: "/user/renters",
      },
    ],*/
  },
  {
    icon: "pe-7s-shopbag",
    label: "Reservations",
    to: "/reservation/list",
  },
  {
    icon: "pe-7s-shield",
    label: "Blocked IP Addresses",
    to: "/blocked-ip-addresses/list",
  },
  {
    icon: "pe-7s-shopbag",
    label: "Reward Points",
    to: "/reward-points/list",
  },
  {
    icon: "pe-7s-shopbag",
    label: "Transactions",
    to: "/transactions/list",
  },
  {
    icon: "pe-7s-shopbag",
    label: "Payouts",
    to: "/payouts/list",
  },
  {
    icon: "pe-7s-shopbag",
    label: "Refunds",
    to: "/refunds/list",
  },
  {
    icon: "pe-7s-tools",
    label: "Storage Types",
    content: [
      {
        label: "Add",
        to: "/storageType/add",
      },
      {
        label: "List",
        to: "/storageType/list",
      },
    ],
  },
  {
    icon: "pe-7s-tools",
    label: "Promo Codes",
    content: [
      {
        label: "Add",
        to: "/promoCodes/add",
      },
      {
        label: "List",
        to: "/promoCodes/list",
      },
    ],
  },
  // {
  //   icon: "pe-7s-tools",
  //   label: "Vehicle Types",
  //   content: [
  //     {
  //       label: "Add",
  //       to: "/vehicleType/add",
  //     },
  //     {
  //       label: "List",
  //       to: "/vehicleType/list",
  //     },
  //   ],
  // },
  {
    icon: "pe-7s-box2",
    label: "Storage Items",
    content: [
      {
        label: "Add",
        to: "/storageItem/add",
      },
      {
        label: "List",
        to: "/storageItem/list",
      },
    ],
  },
  {
    icon: "pe-7s-box2",
    label: "Storage Categories",
    content: [
      {
        label: "List",
        to: "/storageCategory/list",
      },
    ],
  },

  {
    icon: "pe-7s-home",
    label: "Spaces",
    content: [
      {
        label: "List",
        to: "/space/list",
      },
      {
        label: "Sub Spaces",
        to: "/space/sub/spaces",
      },
      // {
      //   label: "Import",
      //   to: "/space/import",
      // },
    ],
  },
  {
    icon: "pe-7s-cash",
    label: "Update Prices",
    to: "/space/update-prices",
  },
  {
    icon: "pe-7s-browser",
    label: "Leads",
    to: "/leads/list",
  },
  {
    icon: "pe-7s-mail",
    label: "SMS Logs",
    to: "/sms-logs/list",
  },

    // {
    //   icon: "pe-7s-home",
    //   label: "Spaces",
    //   to: "/space/list",
    // },
  {
    icon: "pe-7s-config",
    label: "Settings",
    content: [
      {
        label: "General",
        to: "/settings/general",
      },
      {
        label: "Configurations",
        to: "/settings/config",
      },
      {
        label: "Branding",
        to: "/settings/branding",
      },
    ],
  },
];

export const CSRNav = [
  {
    icon: "pe-7s-graph2",
    label: "Dashboard",
    to: "/dashboard",
  },
  {
    icon: "pe-7s-users",
    label: "Users",
    to: "/user/all",
    /*content: [
      {
        label: "All",
        to: "/user/all",
      },
      {
        label: "Hosts",
        to: "/user/hosts",
      },
      {
        label: "Renters",
        to: "/user/renters",
      },
    ],*/
  },
  {
    icon: "pe-7s-home",
    label: "Spots",
    content: [
      {
        label: "Add",
        to: "/spot/add",
      },
      {
        label: "Bulk Add",
        to: "/spot/bulk-add",
      },
      {
        label: "List",
        to: "/spot/list",
      },
    ],
  },
  {
    icon: "pe-7s-shopbag",
    label: "Reservations",
    to: "/reservation/list",
  },
  {
    icon: "pe-7s-shopbag",
    label: "Refunds",
    to: "/refunds/list",
  },
  {
    icon: "pe-7s-browser",
    label: "Leads",
    to: "/leads/list",
  },
  {
    icon: "pe-7s-home",
    label: "Spaces",
    content: [
      {
        label: "List",
        to: "/space/list",
      },
      // {
      //   label: "Sub Spaces",
      //   to: "/space/sub/spaces",
      // },
    ],
  },
  {
    icon: "pe-7s-shopbag",
    label: "Reward Points",
    to: "/reward-points/list",
  },
  {
    icon: "pe-7s-map",
    label: "Dynamic Meta Data",
    content: [
      {
        label: "Add",
        to: "/dynamicmetadata/add",
      },
      {
        label: "List",
        to: "/dynamicmetadata/list",
      },
    ],
  },
];
